var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('Header')],1),_c('v-col',{staticClass:"pt-16 mt-4 h-100",attrs:{"cols":"12"}},[_vm._t("default")],2),_c('v-col',{attrs:{"cols":"12"}},[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }